import { useEffect, useState } from "react";
import axios from "axios";
import { Appid, BaseUrl, Imei, LoginTypeID, SerialNo, Version } from "../../../enum/enum";
import { useLoader } from "../../../context/loaderContext";
import { useAuth } from "../../../context/authContext";
import Layout from "../../../layout/layout";
import moment from "moment";

const LevelWiseIncome = () => {
    const { showLoader, hideLoader } = useLoader();
    const {
        token,
        sessionId,
        userId,
    } = useAuth();

    const [incomeReport, setIncomeReport] = useState([]);
    // const [levelList, setLevelList] = useState([]);
    // const [level, setLevel] = useState("0");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    // const [fromUser, setFromUser] = useState("");

    const getData = async () => {
        try {
            const url = `${BaseUrl}dashboard/IncomeDetailsLvlAndUserWise`;

            const obj = {
                "appSession": {
                    "appid": Appid,
                    "imei": Imei,
                    "loginTypeID": LoginTypeID,
                    "regKey": "",
                    "serialNo": SerialNo,
                    "session": token,
                    "sessionID": sessionId,
                    "uid": 0,
                    "userID": userId,
                    "version": Version

                },
                "request": {
                    "FromDate": fromDate ? moment(fromDate).format("DD-MMM-YYYY") : moment(new Date(), "DD-MMM-YYYY").format("DD-MMM-YYYY"),
                    "ToDate": toDate ? moment(toDate).format("DD-MMM-YYYY") : moment(new Date(), "DD-MMM-YYYY").format("DD-MMM-YYYY"),
                    "ReportType": "LevelWise"
                }
            }

            showLoader();

            const res = await axios.post(url, obj);

            if (res.data?.statuscode == 1) {
                setIncomeReport(res.data.data || []);
            } else {
                setIncomeReport([]);
            }

            hideLoader();
        } catch (e) {
            hideLoader();
            console.log(e.message);
        }
    }

    useEffect(() => {
        getData();
    }, []);

    return (
        <div className="income-report-main">
            <div className="desktop-card card">
                <div className="card-header mb-3">
                    {/* <h5> Level-wise Income </h5> */}
                </div>
                {/* filters */}
                {/* {incomeReport?.length > 0 && ( */}
                <div className="mx-md-3 mx-0 table-filter"
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                        gap: '16px'
                    }}
                >
                    <div>
                        <label className="form-label">From Date</label>
                        <input
                            type="date"
                            className="form-control"
                            value={fromDate || moment(new Date()).format(("YYYY-MM-DD"))}
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="form-label">To Date</label>
                        <input
                            type="date"
                            className="form-control"
                            value={toDate || moment(new Date()).format(("YYYY-MM-DD"))}
                            min={fromDate}
                            onChange={(e) => setToDate(e.target.value)}
                        />
                    </div>
                    {/* <div>
                                            <label className="form-label">Level</label>
                                            <div className="dropdown">
                                                <button className="form-select" type="button" data-bs-toggle="dropdown">
                                                    {(level == '0' ? 'All' : level) || "Select Level"}
                                                </button>
                                                <ul className="dropdown-menu" style={{ maxHeight: "200px", overflowY: "auto", width: "-webkit-fill-available" }}>
                                                    <li><span className="dropdown-item" onClick={() => setLevel("0")}>All</span></li>
                                                    {
                                                        levelList?.map((lev) => (
                                                            <li key={lev.levelNo}>
                                                                <span className="dropdown-item" onClick={() => setLevel(lev.levelNo)}>
                                                                    {lev.levelNo}
                                                                </span>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>

                                        </div> */}
                    {/* <div>
                                            <label className="form-label">From User</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="From User..."
                                                value={fromUser}
                                                onChange={(e) => setFromUser(e.target.value)}
                                            />
                                        </div> */}
                    <div className="d-flex-end">
                        <button
                            type="button"
                            onClick={getData}
                            className="cus-btn-submit"
                        >Search</button>
                    </div>
                </div>
                {/* // )} */}
                {/* records */}
                <div className="desktop-view-only card-body px-0">
                    {
                        incomeReport?.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table align-middle mb-0 bg-hover-effect">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Level NO</th>
                                            {/* <th scope="col">Name</th>
                                                                <th scope="col">User ID</th> */}
                                            <th scope="col">Hold Income</th>
                                            <th scope="col">Total Income</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            incomeReport?.map((el, i) => (
                                                <tr key={i}>
                                                    <td>{i + 1}</td>
                                                    <td>{el.levelNO}</td>
                                                    {/* <td>{el.name}</td>
                                                                        <td>{el.userID}</td> */}
                                                    <td>{el.holdIncome}</td>
                                                    <td>{el.totalIncome}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div>
                                <p className="text-center">No records found.</p>
                            </div>
                        )}
                </div>
                <div className="mobile-view-only mt-3">
                    {incomeReport?.length > 0 ? (
                        incomeReport.map((el, i) => (
                            <div key={i} className="card mb-3 p-3 bg-hover-effect rounded shadow-sm">
                                <div className="d-flex justify-content-between align-items-center my-2">
                                    <span className="badge bg-dark">#{i + 1}</span>
                                    {/* <span className="small">{el.entryDate}</span> */}
                                </div>

                                <div className="d-flex justify-content-between align-items-center my-1">
                                    <strong>Level No:</strong>
                                    <p className="mb-0 f-w-500">{el.levelNO}</p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center my-1">
                                    <strong>Hold Income:</strong>
                                    <p className="mb-0 f-w-500">{el.holdIncome}</p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center my-1">
                                    <strong>Total Income:</strong>
                                    <p className="mb-0 f-w-500">{el.totalIncome}</p>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-center">No records found.</p>
                    )}
                </div>
            </div>
        </div>
    )
}

export default LevelWiseIncome;